export default __webpack_public_path__ + "static/media/dsF.3f578da2.png";